// StoreMenuRankedCardCarousel.js
import React, { useState } from "react";
import {
  Row,
  Col,
  Card,
  CardBody,
  Container,
  Button
} from "reactstrap";

import { Star, Dot } from 'lucide-react';
import VipBadge from "../../components/VipBadge";

import placeholder_image from "assets/images/info/card-placeholder-medium.png";

import "./StoreMenuRankedCardCarousel.css";

function formatFollowCount(count) {
  if (count >= 1_000_000) {
    return (count / 1_000_000).toFixed(1).replace(/\.0$/, '') + 'm';
  } else if (count >= 1_000) {
    return (count / 1_000).toFixed(1).replace(/\.0$/, '') + 'k';
  }
  return count.toString();
}

function getVisualLength(str) {
  let len = 0;
  for (const char of str) {
    // If full-width (CJK) character, count as 2
    if (/[\u4e00-\u9fa5\u3400-\u4DBF\uF900-\uFAFF]/.test(char)) {
      len += 2;
    } else {
      len += 1;
    }
  }
  return len;
}

function truncateByVisualLength(str, maxLen) {
  let len = 0;
  let result = '';

  for (const char of str) {
    const charLen = /[\u4e00-\u9fa5\u3400-\u4DBF\uF900-\uFAFF]/.test(char) ? 2 : 1;
    if (len + charLen > maxLen) break;
    result += char;
    len += charLen;
  }

  return result + (len < getVisualLength(str) ? '...' : '');
}


const RankedCardCarousel = ({ cards, type, imageMap, navigateToUrl }) => {

  return (
    <div className="store-menu-carousel-container">
      <div className="store-menu-carousel-cards-wrapper">
        <div className="store-menu-carousel-cards-inner">

          {cards.map((card, idx) => {
            return (
              <div
                key={idx}
                className={`store-menu-ranked-carousel-card`}
                style={{ 
                  fontSize: "14px",
                  color: "black"
                }}
                onClick={() => {}}
              >
                <div style={{ marginBottom: "5px", position: "relative", width: "100%", padding: "3px" }}>
                  <img className='store-menu-ranked-carousel-img'
                    src={imageMap[card?.image] || placeholder_image}
                    alt={card.title}
                    style={{ }}
                    onClick={()=>{ 
                      const linkUrl = type === "ranking" 
                        ? `/myInfo/storeMenu/topics/${card?._id}` 
                        : `/myInfo/questionSets/${card?._id}`;
                      navigateToUrl(linkUrl); 
                    }}
                  />

                  {type === "qsRanking" && card?.pointReward?.amount && (
                    <div className="d-flex align-items-center"
                      style={{
                        position: "absolute",
                        top: "12px",
                        right: "6px"
                      }}
                    >
                      <div className="mb-1 mb-lg-0 me-2 d-flex align-items-center"
                        style={{
                          height: "18px",
                          padding: "0px 3px 1px 3px",
                          cursor: "default",
                          fontSize: "9px",
                          border: "0.5px solid #ffffff",
                          borderRadius: "3px",
                          color: "#eaeaea",
                          backgroundColor: "#00000170"
                        }}
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          e.currentTarget.blur();
                          return false;
                        }}
                      >
                        <p className="mb-0">{`Tpoint ${card?.pointReward?.amount || 0} 點`}</p>
                      </div>
                    </div>
                  )}

                  <p className="overlapping-number">{idx+1}</p>
                </div>


                {type === "ranking" && (
                  <div style={{ position: "relative", width: "100%"}}>
                    <div className="d-flex flex-column scroll-container-no-scrollbar"
                      style={{ padding: "0px 3px", marginRight: "3px", 
                        overflowX: "scroll", scrollbarWidth: "none", msOverflowStyle: "none" }}
                    >
                      <p className="mb-0" 
                        style={{ fontSize: '15.5px', maxWidth: "95%", cursor: 'pointer', whiteSpace: "nowrap" }}
                        onClick={()=>{ navigateToUrl(`/myInfo/storeMenu/topics/${card?._id}`); }}
                      >
                        {truncateByVisualLength(card?.label || '', 16)}
                      </p>
                      {/*
                      <p style={{ fontSize: '13.5px', color: '#ed8f71', fontWeight: 'bold', margin: '0px 0px 3.5px 0px' }}>
                        {`Tpoint ${card?.pointsAward || 0} 點`}
                      </p>
                      */}
                    </div>

                    {/* Star and VIP level */}
                    <div style={{ marginBottom: '2px', padding: "0px 3px" }}>
                      <Row>
                        <Col className="store-menu-topic-star-col">
                          <div className="d-flex">
                            <p className="mb-0">
                              {
                                card.reviewCount === 0 
                                ? '-'
                                : card.averageRating.toFixed(1)
                              }
                            </p>
                            <Star size={18} fill="#faca82" stroke="none"
                              style={{ margin: '1.8px 2px 0px 2px' }}
                            />
                            <p className="mb-0 text-muted" style={{ fontSize: '13.5px' }}>{`(${card.reviewCount}+)`}</p>
                          </div>

                          <div style={{ margin: '0px 2px 5px 2px' }}>
                            <Dot size={16} /> {/* You can also use a styled div for a smaller solid dot */}
                          </div>

                          <p style={{ fontSize: '13.5px', color: '#5f6265', margin: '0px 0px 0.5px 0px' }}>
                            {card.followerCount || 0}+{` `}已追蹤
                          </p>

                        </Col>
                      </Row>

                    </div>

                  </div>
                )}

                {type === "qsRanking" && (
                  <div style={{ position: "relative", width: "100%"}}>
                    <div className="d-flex flex-column scroll-container-no-scrollbar"
                      style={{ padding: "0px 3px", marginRight: "3px", 
                        overflowX: "scroll", scrollbarWidth: "none", msOverflowStyle: "none" }}
                    >
                      <p className="mb-0" 
                        style={{ fontSize: '15.5px', maxWidth: "95%", cursor: 'pointer', whiteSpace: "nowrap" }}
                        onClick={()=>{ navigateToUrl(`/myInfo/questionSets/${card?._id}`); }}
                      >
                        {truncateByVisualLength(card?.label || '', 14)}
                      </p>
                      {/*
                      <p style={{ fontSize: '13.5px', color: '#ed8f71', fontWeight: 'bold', margin: '0px 0px 3.5px 0px' }}>
                        {`Tpoint ${card?.pointsAward || 0} 點`}
                      </p>
                      */}
                    </div>

                    {/* Star and VIP level */}
                    <div style={{ marginBottom: '2px', padding: "0px 3px" }}>
                      <Row>
                        <Col className="store-menu-topic-star-col">
                          <div className="d-flex">
                            <p className="mb-0">
                              {
                                card.reviewCount === 0 
                                ? '-'
                                : card.averageRating.toFixed(1)
                              }
                            </p>
                            <Star size={18} fill="#faca82" stroke="none"
                              style={{ margin: '1.8px 2px 0px 2px' }}
                            />
                            <p className="mb-0 text-muted" style={{ fontSize: '13.5px' }}>{`(${card.reviewCount}+)`}</p>
                          </div>

                          <div style={{ margin: '0px 2px 5px 2px' }}>
                            <Dot size={16} /> {/* You can also use a styled div for a smaller solid dot */}
                          </div>

                          <div 
                            style={{ 
                              margin: "0px 2px 0px 0px",
                              whiteSpace: "nowrap", 
                              overflow: "scroll", 
                              scrollbarWidth: "none"
                            }}
                          >
                            <p style={{ fontSize: '13.5px', color: '#5f6265', margin: '0px 0px 0.5px 0px' }}>
                              {card.completionCount || 0}+{` `}已填寫
                            </p>
                          </div>

                        </Col>
                      </Row>

                    </div>

                  </div>
                )}


              </div>
            )
          })}

        </div>
      </div>

    </div>
  );
};

export default RankedCardCarousel;
